export default __webpack_public_path__ + "static/media/service-moto.fc00e6cc.png";